module.exports = __webpack_public_path__ + "img/a2add2cffc76e7c2ea0902153b85b445.svg";